<template>
      
        <div :class="['customKanBan', {'customKanBan-active':fullScreen}]"  >
          
             <!-- 自定义看板 -->
             <div class="con">

              <div class="left-demo" id="left-demo" ref="dragContent">
                  <!--  -->
                  <div class="demo-bg-img1  demo-bg" v-show="switchValue">
                        <img :src="dialogImageUrl" width="100%" height="100%" >
                  </div>
                  <div class="demo-bg-mask demo-bg" v-show="maskChecked">
                      <img src="../../assets/customKanBan/mask.png" alt="" width="100%" height="100%" >
                  </div>
                  <div class="demo-bg-img2 demo-bg" :style="nowBgImg" @click.self="leftDemoClick"></div>
                  
                <div class="big-title" :style="fontSize" @mousedown="titleMove($event)">{{titleName}} </div>  
                <!--小模块-->
                  <div :class="['moveBox',{'you-active':item.type == 1},{'moveBox-active':moveBoxIndex == index}]" @mousedown="tagDraggable($event,index)"   
                  v-for="(item,index) in moveBoxList" :key="index" :id="'moveBox'+(index+1)" 
                  :style="item.info" @contextmenu.prevent="currentRightClick($event,index,0)" @click="moveBoxClick_fn(index)" >
                      
                      <div :class="['top-title',{'shape-active':shapeValue == '箭形'}]" :style="topTitleObj" v-if="item.type == 0"> 
                          <div class="delta" v-show="shapeValue =='箭形'" :style="deltaObj"></div>
                          <div class="straight-line" v-show="shapeValue =='直线'" :style="lineObj"></div> 
                          <img :src="item.iconImg" alt="" v-show="item.iconImg != '' && item.iconFlag"> <span :style="item.titleStyle">{{item.titleStyle.name}}</span> 
                      </div>
                      <!-- <el-popconfirm v-show="delFlag==index" title="确定要删除此模板吗？" @onConfirm.stop="del_fn(`moveBox${index+1}`)">
                          <template #reference> 
                              <span style="color:red" @click.stop="del_fn(`moveBox${index+1}`)">删除</span>
                          </template>
                          </el-popconfirm> -->
                      <div class="top-title2" v-if="item.type == 1"> 
                          <img :src="item.iconImg" alt="" v-show="item.iconImg != '' && item.iconFlag"> <span :style="item.titleStyle">{{item.titleStyle.name}}</span> 
                      </div>
                      <div class="small-icon1" v-if="item.type == 1 && item.cheekImgIndex == 0 && item.cheekImgType != '自定义'">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian1.png`)" alt="" class="img1">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian1.png`)" alt="" class="img2">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian2.png`)" alt="" class="img3">
                      </div>
                        <div class="small-icon2" v-if="item.type == 1 && item.cheekImgIndex == 3 && item.cheekImgType != '自定义'">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/line4.png`)" alt="" class="img4" style="height:1px">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/pie1.png`)" alt="" class="img1">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/pie2.png`)" alt="" class="img2">
                      </div>
                      <div class="small-icon2" v-if="item.type == 1 && item.cheekImgIndex == 2 && item.cheekImgType != '自定义'">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/line3.png`)" alt="" class="img4">
                      </div>
                      <div class="small-icon5" v-if="item.type == 1 && item.cheekImgIndex == 5 && item.cheekImgType != '自定义'">
                          <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/round.png`)" alt="" class="img1">
                          <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/round.png`)" alt="" class="img2">
                      </div>
                      <!-- 自定义 -->
                      <div class="small-icon6" v-if="item.cheekImgType == '自定义'">
                          <div class="zidingyi-jianbian"></div>
                          <div class="ziding-line"></div>
                      </div>
                      <div class="lineMoveDiv"   @mousedown="moveLineWidth($event,`moveBox${index+1}`,0,index)"></div>
                      <div class="lineMoveDiv2"  @mousedown="moveLineHeight($event,`moveBox${index+1}`,0,index)"></div>
                  </div>   
                  <!-- 全屏缩小 -->
                  <div class="full-screen" v-if="fullScreenStyle.length != 0" :style="fullScreenStyle[0].info" 
                  @mousedown="zujianTagDraggable($event,0,0)"
                  @click="screenRenovate_fn(0,fullScreenStyle[0])"
                  >
                    <span class="icon iconfont icon-full-screen" v-show="!screenFlag"></span>
                    <span class="icon iconfont icon-suoxiao" v-show="screenFlag"></span>
                    <div class="screen" ></div>
                  </div>
                  <!-- 刷新 -->
                  <div class="renovate" v-if="renovateStyle.length != 0" :style="renovateStyle[0].info" 
                  @mousedown="zujianTagDraggable($event,0,1)"
                  @click="screenRenovate_fn(1,renovateStyle[0])"
                  >
                      <i class="el-icon-refresh-right"></i>
                      <div class="screen" ></div>
                  </div>

                  <!-- 天气 -->
                  <div :class="['weather',{'weather-active':weathIndex == index}]" v-for="(item,index) in weatherList" :key="index + 100" :style="item.info" 
                  @contextmenu.prevent="currentRightClick($event,index,1)"
                  @mousedown="zujianTagDraggable($event,index,item.type)" 
                  :id="'weather'+(index+1)">
                      <div class="weather-item" v-show="item.weatherCheckList.indexOf('天气类型') != -1">
                        <img :src="weatherImg"> {{Weather.weather}}
                      </div>
                      <div class="weather-item" v-show="item.weatherCheckList.indexOf('温度') != -1">
                          {{Weather.temperature}} ℃
                      </div>
                      <div class="weather-item" v-show="item.weatherCheckList.indexOf('风力') != -1">
                          {{Weather.winddirection}}风{{Weather.windpower}}级
                      </div>
                      <div class="weather-item" v-show="item.weatherCheckList.indexOf('湿度') != -1">
                          湿度 {{Weather.humidity}}％
                      </div>
                      <div class="tuo" @click="weathIndex = index;moveBoxIndex = timerIndex = -1"></div>
                  </div>

                  <!-- 日期 -->
                  <div :class="['timer',{'weather-active':timerIndex == index}]"   v-for="(item,index) in timerList" :key="index + 150" :style="item.info"  
                  @contextmenu.prevent="currentRightClick($event,index,2)"
                    @mousedown="zujianTagDraggable($event,index,item.type)" :id="'timer'+(index+1)">
                      <div class="weather-item" v-show="item.timerCheckList.indexOf('日期') != -1">
                          {{nowTime}}
                      </div>
                      <div class="weather-item" v-show="item.timerCheckList.indexOf('时间') != -1">
                          {{nowMin}}
                      </div>
                      <div class="weather-item" v-show="item.timerCheckList.indexOf('星期') != -1">
                          {{nowWeek}}
                      </div>
                      <div class="tuo" @click="timerIndex = index;moveBoxIndex = weathIndex =  -1"></div>
                  </div>

                  <!-- 折线图 -->
                  <div :class="['line-chart',{'chart-active':chartIndex == index}]" v-for="(item,index) in lineChartList" :key="index + 200" :style="item.info" 
                  @contextmenu.prevent="currentRightClick($event,index,3)"
                  @mousedown="chartDraggable($event,index,'折线图')"
                  @click="chartClick_fn(index,'折线图')" :id="'line-chart'+(index+1)">
                       <div :id="'proportion'+(index+1)" style="width:100%;height:100%"></div>
                       <div class="line-chart-move"   @mousedown="moveChartWidth($event,`line-chart${index+1}`,1,index)"></div>
                       <div class="line-chart-move2"   @mousedown="moveChartHeight($event,`line-chart${index+1}`,1,index)"></div>
                  </div>

                  <!-- 柱状图 -->
                  <div :class="['bar-chart',{'chart-active':barChartIndex == index}]" v-for="(item,index) in barChartList" :key="index + 250" :style="item.info" 
                  @mousedown="chartDraggable($event,index,'柱状图')"
                  @contextmenu.prevent="currentRightClick($event,index,4)"
                  @click="chartClick_fn(index,'柱状图')" :id="'bar-chart'+(index+1)">
                       <!-- <p >单位：</p> -->
                       <div :id="'proportionBar'+(index+1)" style="width:100%;height:100%"></div>
                       <div class="bar-chart-move"   @mousedown="moveChartWidth($event,`bar-chart${index+1}`,2,index)"></div>
                       <div class="bar-chart-move2"   @mousedown="moveChartHeight($event,`bar-chart${index+1}`,2,index)"></div>
                  </div>

                  <!-- 饼图 -->
                   <div :class="['pie-chart',{'chart-active':pieChartIndex == index}]" v-for="(item,index) in pieChartList" :key="index + 300" :style="item.info" 
                   @contextmenu.prevent="currentRightClick($event,index,5)"
                  @mousedown="chartDraggable($event,index,'饼图')"
                  @click="chartClick_fn(index,'饼图')" :id="'pie-chart'+(index+1)">
                       <!-- <p >单位：</p> -->
                       <div :id="'proportionPie'+(index+1)" style="width:100%;height:100%"></div>
                       <div class="pie-chart-move"   @mousedown="moveChartWidth($event,`pie-chart${index+1}`,3,index)"></div>
                       <div class="pie-chart-move2"   @mousedown="moveChartHeight($event,`pie-chart${index+1}`,3,index)"></div>
                  </div>

                  <!-- 单值 -->
                  <div :class="['single-value',{'single-active':singleIndex == index},{'fusingle':item.type == 1}]" v-for="(item,index) in singleList" :key="index + 350" 
                  :style="item.info"
                  @contextmenu.prevent="currentRightClick($event,index,6)"
                  @mousedown="singleDraggable($event,index)" @click="singleClick_fn(index)" :id="'single-value'+(index+1)">
                    <div class="single-item" v-if="item.type == 0">
                        <div class="single-title" :style="{'backgroundColor':item.titleBgColor,'color':item.titleColor,'fontSize':item.titleIcon}">
                          {{item.titleName}}
                        </div>
                        <div class="single-val" :style="{'backgroundColor':item.valBgColor,'color':item.valColor,'fontSize':item.valIcon}">
                          值
                        </div>
                    </div>
                    <div class="single-item" v-if="item.type == 1">
                        <div class="fuhe-origina" :style="item.yuanXY" @mousedown="singleItemDraggable($event,index)" v-show="item.switchVal"><span :style="item.yuanStyle" >
                          原值</span><span :style="item.yuanValStyle">{{item.originalValue}}</span></div>
                        <div class="fuhe-huan" :style="item.hangXY" @mousedown="singleItemDraggable($event,index)"><span :style="item.hangStyle">上{{item.timeVal == 'MON'? '月':'日'}}环比</span>
                        <span :style="item.huanValStyle" :class="item.sameCompareValue > 0 ? 'rise' : 'fall'">{{item.sameCompareValue > 0 ? '+' :'-'}}{{item.sameCompareValue}}%</span></div>
                        <div class="fuhe-tong" :style="item.tongXY" @mousedown="singleItemDraggable($event,index)"><span :style="item.tongStyle">去年同比</span>
                        <span :style="item.tongValStyle"  :class="item.lastCompareValue > 0 ? 'rise' : 'fall'">{{item.lastCompareValue > 0 ? '+' :'-'}}{{item.lastCompareValue}}%</span></div>
                    </div>
                    <div class="single-move" @mousedown="singleMoveLineWidth($event,`single-value${index+1}`,1,index)"></div>
                    <div class="single-move2" @mousedown="singleMoveLineHeight($event,`single-value${index+1}`,1,index)"></div>
                  </div>

                  <!-- 列表 -->
                  <div :class="['tabulation',{'tabulation-active':tabulationIndex == index},'tabulationone']" v-for="(item,index) in tabulationList" :key="index + 400" 
                  :style="item.info"
                  @contextmenu.prevent="currentRightClick($event,index,7)"
                  @click="tabulationClick_fn(index)" @mousedown="tabDraggable($event,index)" id="tabulation1">
                      
                       
                       <div class="tabulation-item" v-for="(t,i) in tabulationArr" :key="i">
                          <div class="tab-left">
                             <div class="grade warning" v-if="t.type == 'warning'" :style="item.warning">预警</div>
                             <div class="grade alarm" v-if="t.type == 'alarm'" :style="item.alarm">告警</div>
                             <div class="grade notice" v-if="t.type == 'notice'" :style="item.notice">通知</div>
                             <el-tooltip class="item" effect="dark" content="内容" placement="top">
                                 <div class="item-content" :style="item.con">内容</div>
                              </el-tooltip>
                          </div>
                          <div class="tab-time" :style="item.time">2023-5-22</div>
                       </div>
                        <div class="tabulation-move" @mousedown="singleMoveLineWidth($event,`tabulation1`,2,index)"></div>
                        <div class="tabulation-move2" @mousedown="singleMoveLineHeight($event,`tabulation1`,2,index)"></div>
                  </div>

                  <!-- 图库 -->
                  <div :class="['gallery-imgs',{'gallery-active':galleryIndex == index}]" v-for="(item,index) in galleryList" :key="index + 500" :style="item.info"
                  @contextmenu.prevent="currentRightClick($event,index,8)"
                   @mousedown="galleryDraggable($event,index)"
                  @click="galleryClick_fn($event,index)"
                  :id="'gallery-imgs'+(index+1)">
                       <div class="img-item">
                           <img :src="item.imgUrl" draggable="false">
                       </div>
                      <div class="gallery-move" @mousedown="singleMoveLineWidth($event,`gallery-imgs${index+1}`,3,index)"></div>
                      <div class="gallery-move2" @mousedown="singleMoveLineHeight($event,`gallery-imgs${index+1}`,3,index)"></div>
                  </div>

                  <!-- 进度条 -->
                  <div :class="['myelprogress',{'progress-active':progressIndex == index}]" v-for="(item,index) in progressList" :key="index + 600" :style="item.info"
                  @contextmenu.prevent="currentRightClick($event,index,9)"
                  :id="'myelprogress'+(index+1)" @click="progressClick_fn(index)"
                   @mousedown="progressDraggable($event,index)">
                       <div class="progress-item">
                          <el-progress :percentage="item.lastCompare" :color="item.lastColor" :format="format"></el-progress>
                       </div>
                        <div class="progress-item" :style="{'marginLeft':item.spacing}">
                           <el-progress :percentage="item.sameCompare" :color="item.sameColor" :format="format"></el-progress>
                        </div>
                         <div class="progress-move" @mousedown="singleMoveLineWidth($event,`myelprogress${index+1}`,4,index)"></div>
                       <!-- <span>环比{{item.lastCompare}}</span> -->
                       <!-- <span>同比{{item.sameCompare}}</span> -->

                  </div>

                  <!-- 说明文字 -->
                  <div :class="['mycaption',{'caption-active':captionIndex == index}]" v-for="(item,index) in captionList" :key="index + 650" :style="item.info" 
                  @contextmenu.prevent="currentRightClick($event,index,10)"
                  @mousedown="captionDraggable($event,index)"
                  :id="'mycaption'+(index+1)"
                  @click="captionClick_fn(index)">
                    <div>
                      <span :style="{'fontSize':item.fontSize,'color':item.color}">{{item.titleName}}</span>
                    </div>
                  </div>

                  <!-- 右键删除 -->
                   <div class="add-del"  @click.stop="addDel_fn" v-show="isRightMenu" :style="rightMenStyle">
                        <div class="eait">
                              <div :class="['eait-item',{'eait-active':eaitIndex == i}]" v-for="(t,i) in rightMenuList" :key="i">
                                <span>{{t.name}}</span>
                                <el-input v-model="t.key" @focus="rightFocus(t.name,i)" @blur="curBlur_fn(t.key)" @keyup.enter.native="$event.target.blur"></el-input>
                              </div>
                        </div>
                        <div class="del-btn">
                            <div @click.stop="del_fn(elementIndex,elementType)"> <p>删除</p>  <span>delet</span></div>
                            <!-- <div @click.stop="copy_fn()"> <p>复制</p>  <span>ctrl+c</span></div>
                            <div> <p>粘贴</p>  <span>ctrl+v</span></div> -->
                        </div>
                      </div>




                   <div class="btns">
                     <img src="../../assets/customKanBan/setting.png" @click="settingFlag_fn(false)" v-show="settingFlag" >
                     <img src="../../assets/customKanBan/close.png" @click="settingFlag_fn(true)" v-show="!settingFlag" >
                    
                     <!-- <button @click="quanping">按钮</button> -->
                  </div>
                  <div class="is-full">
                   <span class="icon iconfont icon-full-screen" @click="fullScreen = !fullScreen" v-show="fullScreen"></span>
                    <span class="icon iconfont icon-suoxiao" @click="fullScreen = !fullScreen" v-show="!fullScreen"></span>
                  </div>

              </div>
       
              <div class="right-select" v-show="!settingFlag">
                  <el-scrollbar style="height:100%;width: 100%;">
                  <div class="right-title">
                      <div class="t-left">看板编辑</div>
                      <div class="move-right" style="flex: 1;height: 100%;" @mousedown="formulaBar($event)"></div>
                      <i class="el-icon-close" @click="settingFlag_fn(true)"></i>
                  </div>
                  <div class="tab" style="width:100%">
                    <el-scrollbar style="height:100%;width: 100%;">
                      <span v-for="(item,index) in tabList" :key="index" :class="{'span-active':index == tabIndex}" @click="tabIndex=index">{{item}}</span>
                      </el-scrollbar>
                  </div>
                  <!-- 框架编辑 -->
                  <div class="kuajia" v-if="tabIndex == 0">
                      <!-- 背景图片 -->
                          <div class="m-left zhuti">
                              <div class="m-left"><span></span> 选择主题</div>
                              <el-upload
                                      action=""
                                      :show-file-list="false"
                                      :auto-upload="false"
                                      accept="image/*"
                                      list-type="picture-card"
                                      :on-change="zhutiImg_fn"
                                  >
                                      <el-button size="small" type="primary" class="zhuti-img" plain>上传自定义主题</el-button>
                                  </el-upload>
                            
                          </div>
                          <div class="bigbg">
                              <el-scrollbar style="height:95%;width: 100%;">
                                      <div :class="['bg-img',{'active':index == activeIndex}]" v-for="(item,index) in bgImgList" :key="index" @click="change_bg(index)">
                                          <img :src="item.url" alt="">
                                          
                                          <div>主题{{index +1}}</div>
                                      </div>
                              </el-scrollbar>
                          </div>
                          <div class="m-left"><span></span> 选择背景图片</div>
                          <div class="mask-img">
                              <div class="noesd">
                                  <el-upload
                                      action=""
                                      :show-file-list="false"
                                      :auto-upload="false"
                                      accept="image/*"
                                      list-type="picture-card"
                                      :on-change="handlePictureCardPreview"
                                  >
                                      <i class="el-icon-plus"  v-show="!dialogVisible"></i>
                                      <img width="100%" height="100px" v-show="dialogVisible" :src="dialogImageUrl" alt="">
                                  </el-upload>
                                  </div>
                            <el-switch v-model="switchValue" active-text="启用" inactive-text="" @change="switch_fn" :disabled='!dialogVisible'></el-switch>
                            <el-checkbox v-model="maskChecked">使用遮罩</el-checkbox>
                          </div>
                          <div class="m-left" style="margin-bottom:20px"><span></span> 编辑标题</div>
                          <div class="style-name nowarp">
                              <span >名称：</span><el-input   v-model="titleName" placeholder="请输入标题名称"  > </el-input>
                          </div>
                              <div class="style-size nowarp">
                              <span >大小：</span>  
                                  <el-select v-model="sizeValue" placeholder="请选择" @change="fontSize_fn">
                                              <el-option v-for="item in fontSizeList"  :key="item.value" :label="item.label"  :value="item.value"> </el-option>
                                  </el-select>
                          </div>
                              <div class="style-color nowarp">
                              <span >颜色：</span><el-color-picker v-model="titleColor" show-alpha @change="color_fn"></el-color-picker>
                          </div>
                  </div>
                  <!-- 模块标题编辑 -->
                  <moduleTitle v-if="tabIndex == 1" 
                  :nowModulTitleObj='nowModulTitleObj' 
                  @modelTitleName_fn="modelTitleName_fn" 
                  @coordinate_fn='coordinate_fn' 
                  @moduleTitle_fn='moduleTitle_fn' 
                  @shape_fn="shape_fn" 
                  @moduleTitleColor_fn="moduleTitleColor_fn" 
                  @nowIcon_fn="nowIcon_fn"
                  @nowCheek_fn='nowCheek_fn'
                  @iconFlag_fn="iconFlag_fn"
                  
                  ></moduleTitle>
                  <!-- 看板组件 -->
                  <assembly ref="assembly" v-if="tabIndex == 2" @assembly_fn='assembly_fn' :weathObj='weathObj' 
                  @weathers_fn="weathers_fn"  
                  @timers_fn='timers_fn' 
                  :trimerObj='trimerObj'
                  @screens_fn='screens_fn'
                  ></assembly>
                  <!-- 图表 -->
                  <kanBanChart v-if="tabIndex == 3" @chart_fn='chart_fn' :nowChartData='nowChartData' @changChart='changChart' :routeData='routeData'></kanBanChart>

                  <!-- 单值 -->
                  <singleValue v-if="tabIndex == 4" @single_fn='single_fn' :nowSingleData='nowSingleData' :routeData='routeData' @changSingle_fn='changSingle_fn' @fusingleChange_fn='fusingleChange_fn'></singleValue>
                   
                   <!-- 列表 -->
                   <tabulation  v-if="tabIndex == 5" @tabulation_fn='tabulation_fn' :nowTabulationData='nowTabulationData' @changtabulation_fn='changtabulation_fn'></tabulation>

                    <!-- 进度条 -->
                  <myprogress v-if="tabIndex == 6" @progress_fn='progress_fn' :routeData='routeData' :progressObj='progressObj' @changPro_fn='changPro_fn'></myprogress>

                   <!-- 图库 -->
                   <gallery  v-if="tabIndex == 7" @gallery_fn='gallery_fn' :galleryObj='galleryObj' @changGallery_fn='changGallery_fn' ></gallery>

                   <!-- 文字 -->
                  <mycaption v-if="tabIndex == 8" @caption_fn='caption_fn' :captionObj='captionObj' @changCaption_fn='changCaption_fn'></mycaption>
              
                 
                  <!-- <el-button type="primary" @click="addMoveBox_fn">添加</el-button>-->
                  <!-- <button @click="generateImages">下载图片</button>  -->
                  </el-scrollbar>
                  <el-button type="primary" size="small" @click="preserve_fn" v-show="!settingFlag" style="position: absolute;bottom: 10px;right: 10px;">保存看板</el-button>

              </div>
              
             </div>
             <div class="el-loading-mask" v-show="loading" style="z-index: 9999;">
                        <div class="el-loading-spinner">
                            <svg viewBox="25 25 50 50" class="circular">
                                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                            </svg>
                           <p>正在保存....</p>
                        </div>
             </div>
              <!-- 新增修改 -->
        <el-dialog width="25%" v-dialogDrag title="保存看板"  :close-on-click-modal='false'
          :visible.sync="dialogAdd">
        <div style="display: flex;">
            <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 120px;padding-top: 10px;">
               <el-form-item label="看板名称：" prop="biName">
                          <el-input v-model="temp.biName" style="width:240px" placeholder="请输入看板名称"></el-input>
                </el-form-item>
                <el-form-item label="看板备注：" >
                          <el-input v-model="memo" style="width:240px" placeholder="请输入备注"></el-input>
                          <!-- <p style="font-size:12px;color:red">Tips：保存</p> -->
                </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogAdd = false">取 消</el-button>
            <el-button type="primary" @click="save_fn('temp')" :disabled="disabledFlag">确定<span v-if="countNum != 0">({{countNum}})</span></el-button>
          </div>
	    	</el-dialog>
             
        </div>
  
</template>

<script>
import html2canvas from 'html2canvas'
import CircularJSON from 'circular-json'
  import moduleTitle from "./moduleTitle"; //模块标题
  import assembly from "./assembly"; // 组件配置
  import kanBanChart from "./kanBanChart"; // 图表配置
  import singleValue from "./singleValue"; // 单值配置
  import tabulation from "./tabulation"; // 单值配置
  import gallery from "./gallery"; // 图库
  import myprogress from "./progress"; // 进度条
  import mycaption from "./caption"; // 说明文字
  
  import resourcesStore from '@/cache/resourcesStore.js'
  import * as echarts from "echarts";
  import {saveBI} from "../../api/customKanBanApi";

export default {
     components: { 
        moduleTitle,
        assembly,
        kanBanChart,
        singleValue,
        tabulation,
        gallery,
        myprogress,
        mycaption
      },
    data(){
        return {
          editKanBanID:"",
          loading:false,
          fullScreen:true,
          //右键菜单
          rightMenStyle:{},
          isRightMenu:false,
          rightChangeList:{},
          rightChangeType:"",
          beforeLeft:0,
          beforeTop:0,
          elementType:"",
          elementIndex:-1,

          captionList:[],//说明文字
          captionIndex:-1,
          captionObj:{},
          customColor: 'red',
          //进度条
          progressList:[],
          progressIndex:-1,
          progressObj:{},
          //进度条上
          //星号必填
          countNum:5,
          memo:"",
          dialogVisible:false,
          disabledFlag:true,

          dialogAdd:false,
          temp:{},
          dingshiqi:null,
          rules: {
                biName: [
                    { required: true, message: '请输入看板名称', trigger: 'blur' }
                ]
                },
          //以上是保存看板
          routeData:{},//路由参数
          galleryIndex:-1,//图库选中
          galleryList:[],//图库
          galleryObj:{},//点击图库图片
          zujianFlag:false,//组件操作
          screenFlag:false,//全屏/缩小
          //天气
          Weather:{},
          weathObj:{},
          weatherList:[],
          weathIndex:-1,
          weatherImg:"",
          setIntervalTimer:null,
          //时间
          timerList:[],
          trimerObj:{},
          setTimer:null,
          timerIndex:-1,
          nowTime:"",
          nowWeek:"",
          nowMin:"",
          //右击菜单
          rightMenuList:[
            {
              'name':'X',
              'key':'left'
            },
            {
              'name':'Y',
              'key':'top'
            },
            {
              'name':'宽',
              'key':'width'
            },
            {
              'name':'高',
              'key':'height'
            },
          ],
          eaitIndex:-1,
          nowInputVal:0,
          moveBoxIndex:-1,//当前选中模块的索引
          nowModulTitleObj:{},//当前选中的模块标题样式
          rightClickMenu:false,//右击出现菜单
            titleName:"大标题",
            settingFlag:false,//控制右侧小模块的弹出跟收起
            //小模块
            moveBoxList:[],
            //右边选项卡
            tabList:['框架','模块','组件','图表','单值','列表','进度条','图库','文字'],
            tabIndex:0,
            offsetWidth:0,//宽度
            offsetHeight:0,//高度
            delFlag:-1, //控制删除是否显示
            bgImgList:[
                {
                    'url':require('@/assets/customKanBan/blue.jpg'),
                    'urlTran':require('@/assets/customKanBan/blueTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/green.png'),
                    'urlTran':require('@/assets/customKanBan/greenTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/yellow.jpg'),
                    'urlTran':require('@/assets/customKanBan/yellowTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/qing.png'),
                    'urlTran':require('@/assets/customKanBan/qingTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme5.png'),
                    'urlTran':require('@/assets/customKanBan/theme5Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme6.png'),
                    'urlTran':require('@/assets/customKanBan/theme6Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme7.png'),
                    'urlTran':require('@/assets/customKanBan/theme7Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme8.png'),
                    'urlTran':require('@/assets/customKanBan/theme8Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/智慧工业园区.png'),
                },
            ],//背景数据
            //正在使用的背景
            nowBgImg:{},
            activeIndex:0,//高亮背景框
            bgImgPhoto:"",//背景图片
            maskChecked:false,//是否使用遮罩
            switchValue:false,//是否启动背景图片
            //标题字体大小
            sizeValue:24,
            fontSizeList:[],
            fontSize:{},
            //标题字体颜色
            titleColor:'#fff',
              dialogImageUrl: '',
            dialogVisible: false,
            coordinate:{},//新增小模块的坐标
            shapeValue:"矩形", //小模块标题形状
            moduleBgColor:true, //小模块标题是否渐变
            moduleTitleColor:"#407cdd",//小模块标题颜色
            modelTitleName:{},//小模块标题文字
            topTitleObj:{} ,//小模块标题样式
            lineObj:{},//直线样式
            deltaObj:{},//箭头三角形样式
            nowIcon:require(`@/assets/customKanBan/白色模块/icon1.png`),//当前图标
            copyData:[],//复制
            layerX:0,//粘贴的位置
            layerY:0,//粘贴的位置
            fullScreenStyle:[],//全屏样式
            renovateStyle:[], //刷新样式

            lineChartList:[],//折线图的数据
            barChartList:[],//柱状图的数据
            pieChartList:[],//饼图图的数据
            nowChartData:{},//当前选中的图表
            chartIndex:-1,//选中的折线图表模块
            barChartIndex:-1,//选中的柱状图模块
            pieChartIndex:-1,//选中的饼图图模块
            proportionListLine:[],//初始化折线图图例
            proportionListBar:[],//初始化柱状图图例
            proportionListPie:[],//初始化饼图图例
            chartType:"",

            singleList:[],//单值
            singleIndex:-1,//单值
            nowSingleData:{},
            tabulationList:[],//列表
            tabulationIndex:-1,
            tabulationArr:[],
            tabulationArrCopy:[
              {
                'type':"alarm",
              },
              {
                'type':"warning",
              },
            ],
            nowTabulationData:{},
            editFlag:false,
        }
    },
    watch:{
       settingFlag(val){
        // setTimeout(() => {
        //      var offsetHeight = document.getElementById("left-demo").offsetHeight
        //      var offsetWidth = document.getElementById("left-demo").offsetWidth
          
        //      this.moveBoxList.forEach(item => {
        //         item.left = ((item.info.left.substring(0,item.info.left.length-1) / 100) * offsetWidth).toFixed(1)
        //         item.top = ((item.info.top.substring(0,item.info.top.length-1) / 100) * offsetHeight).toFixed(1)
        //         item.width = ((item.info.width.substring(0,item.info.width.length-1) / 100) * offsetWidth).toFixed(1)
        //         item.height = ((item.info.height.substring(0,item.info.height.length-1) / 100) * offsetHeight).toFixed(1)

        //      })
        // },600)
       },
     
       
       weathIndex(val){
        
        if(val != -1){
          this.tabIndex = 2
          this.weathObj = this.weatherList[val]
        }else {
           this.weathObj = {}
        }
       },
       timerIndex(val){
          if(val != -1){
          this.tabIndex = 2
          this.trimerObj = this.timerList[val]
          }else {
            this.trimerObj = {}
          }
       },
       
    },
    mounted(){
      this.routeData = this.$route.params
      document.onkeydown=(e)=>{
	    	if(e.keyCode == 46){//这是delete健，当然也可以根据自己的需求更改
           if(this.moveBoxIndex != -1 && this.eaitIndex == -1){
              this.del_fn(this.moveBoxIndex,'模块')
              // this.del_fn(`moveBox${this.moveBoxIndex+1}`)
           }else if(this.weathIndex != -1){
                this.del_fn(this.weathIndex,'天气')
                // this.del_fn(`weather${this.weathIndex+1}`)
           }else if(this.timerIndex != -1){
                this.del_fn(this.timerIndex,'时间')
                // this.del_fn(`timer${this.timerIndex+1}`)
           }else if(this.chartIndex != -1){
                this.del_fn(this.chartIndex,'折线图')
              //  this.del_fn(`line-chart${this.chartIndex+1}`)
           }else if(this.barChartIndex != -1){
              this.del_fn(this.barChartIndex,'柱状图')
              //  this.del_fn(`bar-chart${this.barChartIndex+1}`)
           }else if(this.pieChartIndex != -1){
              this.del_fn(this.pieChartIndex,'饼图')
              //  this.del_fn(`pie-chart${this.pieChartIndex+1}`)
           }else if(this.singleIndex != -1){
              this.del_fn(this.singleIndex,'单值')
              //  this.del_fn(`single-value${this.singleIndex+1}`)
           }else if(this.tabulationIndex != -1){
              this.del_fn(this.tabulationIndex,'列表')
           }else if(this.progressIndex != -1){
              this.del_fn(this.progressIndex,'进度条')
           }else if(this.galleryIndex != -1){
              this.del_fn(this.galleryIndex,'图库')
           }else if(this.captionIndex != -1){
              this.del_fn(this.captionIndex,'文字')
           }
	     	}
    

    	}
       for(let i = 2;i<=14;i++){
          this.tabulationArrCopy.push({'type':'notice'})
       }
        for(let i = 0;i<=5;i++){
          this.tabulationArr.push(this.tabulationArrCopy[i])
       }
        
        for(let i = 24;i <= 40;i++){
            if(i % 2 == 0){
                this.fontSizeList.push({
                    value:i,
                    label:i
                })
            }
        }
              this.offsetWidth = document.getElementById("left-demo").offsetWidth
              this.offsetHeight = document.getElementById("left-demo").offsetHeight
                this.Weather = (JSON.parse(localStorage.getItem('Weather')))
              if(this.Weather){
                this.weatherImg = require(`../../../public/static/image/科技蓝/weather/${ this.Weather.weather}.png`)
              }
              var that =  this
        //天气
        this.setIntervalTimer =  setInterval(() => {
          this.Weather = (JSON.parse(localStorage.getItem('Weather')))
          if(this.Weather){
            that.weatherImg = require(`../../../public/static/image/科技蓝/weather/${ that.Weather.weather}.png`)
            }
        },1800000)
        //日期
         this.setTimer = setInterval(() => {
           this.timer_fn()
        },1000)
          var arr = this.$store.deviceStore.state.kanBanEditList
          if(arr.length != 0){
             var myExample = CircularJSON.parse(arr)
            this.setExample(myExample[0])
            // this.editFlag = true
            console.log("实例",myExample[0]);
            // this.editKanBanID = 
             this.tranPercentage()
          }
       
          
    },
    destroyed() {
      document.onkeydown=(e)=>{}
			clearInterval(this.setIntervalTimer)
			clearInterval(this.setTimer)
		},
		beforeDestroy(){
      document.onkeydown=(e)=>{}
			 clearInterval(this.setIntervalTimer)
			 clearInterval(this.setTimer)
		},
    methods:{
       // 转化实例方法
      setExample(data){
           //右键菜单
        this.captionList = data.captionList,//说明文字
        this.galleryList = data.galleryList,//说明文字
          //进度条
          this.progressList = data.progressList,
          //进度条上
          //星号必填
          this.countNum = data.countNum,
          this.memo = data.memo,
          this.dialogVisible = data.dialogVisible,
          this.disabledFlag = data.disabledFlag,
          this.temp = data.temp,
          this.dingshiqi = data.dingshiqi,
          this.rules =  data.rules,
          //以上是保存看板
          //天气
          this.Weather = data.Weather,
          this.weathObj = data.weathObj,
          this.weatherList =data.weatherList,
          this.weathIndex = data.weathIndex,
          this.weatherImg = data.weatherImg,
          this.setIntervalTimer = data.setIntervalTimer,
          //时间
          this.timerList = data.timerList,
          this.trimerObj = data.trimerObj,
          this.setTimer = data.setTimer,
          this.timerIndex = data.timerIndex,
          this.nowTime = data.nowTime,
          this.nowWeek = data.nowWeek,
          this.nowMin = data.nowMin,
          //右击菜单
          this.rightMenuList =data.rightMenuList,
          this.eaitIndex = data.eaitIndex,
          this.nowInputVal = data.nowInputVal,
          this.moveBoxIndex = data.moveBoxIndex,//当前选中模块的索引
          this.nowModulTitleObj = data.nowModulTitleObj,//当前选中的模块标题样式
          this.rightClickMenu = data.rightClickMenu,//右击出现菜单
            this.titleName = data.titleName,
            this.settingFlag = data.settingFlag,//控制右侧小模块的弹出跟收起
            //小模块
            this.moveBoxList = data.moveBoxList,
            //右边选项卡
            this.tabList = data.tabList,
            this.tabIndex = data.tabIndex,
            this.offsetWidth = data.offsetWidth,//宽度
            this.offsetHeight = data.offsetHeight,//高度
            this.delFlag = data.delFlag, //控制删除是否显示
            this.bgImgList = data.bgImgList,//背景数据
            //正在使用的背景
            this.nowBgImg = data.nowBgImg,
            this.activeIndex = data.activeIndex,//高亮背景框
            this.bgImgPhoto = data.bgImgPhoto,//背景图片
            this.maskChecked = data.maskChecked,//是否使用遮罩
            this.switchValue = data.switchValue,//是否启动背景图片
            //标题字体大小
            this.sizeValue = data.sizeValue,
            this.fontSizeList = data.fontSizeList,
            this.fontSize = data.fontSize,
            //标题字体颜色
            this.titleColor = data.titleColor,
              this.dialogImageUrl =  data.dialogImageUrl,
            this.dialogVisible =  data.dialogVisible,
            this.coordinate = data.coordinate,//新增小模块的坐标
            this.shapeValue = data.shapeValue, //小模块标题形状
            this.moduleBgColor = data.moduleBgColor, //小模块标题是否渐变
            this.moduleTitleColor = data.moduleTitleColor,//小模块标题颜色
            this.modelTitleName = data.modelTitleName,//小模块标题文字
            this.topTitleObj = data.topTitleObj ,//小模块标题样式
            this.lineObj = data.lineObj,//直线样式
            this.deltaObj = data.deltaObj,//箭头三角形样式
            this.nowIcon =data.nowIcon,//当前图标
            this.copyData =data.copyData,//复制
            this.layerX = data.layerX,//粘贴的位置
            this.layerY = data.layerY,//粘贴的位置
            this.fullScreenStyle = data.fullScreenStyle,//全屏样式
            this.renovateStyle = data.renovateStyle, //刷新样式

            this.lineChartList = data.lineChartList,//折线图的数据
            this.barChartList = data.barChartList,//柱状图的数据
            this.pieChartList = data.pieChartList,//饼图图的数据
            this.nowChartData = data.nowChartData,//当前选中的图表
            // this.proportionListBar  = data.proportionListBar,
            // this.proportionListLine  = data.proportionListLine,
            // this.proportionListPie  = data.proportionListPie,
            this.chartIndex = data.chartIndex,//选中的折线图表模块
            this.barChartIndex = data.barChartIndex,//选中的柱状图模块
            this.pieChartIndex = data.pieChartIndex,//选中的饼图图模块

            this.chartType = data.chartType,

            this.singleList = data.singleList,//单值
            this.singleIndex = data.singleIndex,//单值
            this.nowSingleData = data.nowSingleData,
            this.tabulationList =data.tabulationList,//列表
            this.tabulationIndex = data.tabulationIndex,
            this.tabulationArr = data.tabulationArr,
            this.tabulationArrCopy = data.tabulationArrCopy,
            this.nowTabulationData = data.nowTabulationData
            this.quxiaoAll()
            var that = this
                  setTimeout(() => {
                   that.barChartList.forEach((item,index) => {
                        that.proportionListBar.push(echarts.init(document.getElementById(`proportionBar${index + 1}`)));
                        that.proportionListBar[index].setOption(item.optionData,true);
                  })
                },500)

      },

      //通用鼠标右键
      currentRightClick(e,index,type){
         this.rightMenStyle = {
           'left':e.clientX +'px',
           'top':e.clientY +'px',
         }
         this.quxiaoAll()
         this.isRightMenu = true
         var list  = []
        
         if(type == 0){ //柱状图
              list = this.moveBoxList
              this.elementType = '模块'
              this.moveBoxIndex = index
         }else if(type == 1){
             list = this.weatherList
              this.elementType = '天气'
               this.weathIndex = index
         }else if(type == 2){
             list = this.timerList
              this.elementType = '时间'
               this.timerIndex = index
         }else if(type == 3){
             list = this.lineChartList
              this.elementType = '折线图'
               this.chartIndex = index
         }else if(type == 4){
             list = this.barChartList
              this.elementType = '柱状图'
               this.barChartIndex = index
         }else if(type == 5){
             list = this.pieChartList
              this.elementType = '饼图'
               this.pieChartIndex = index
         }else if(type == 6){
             list = this.singleList
              this.elementType = '单值'
               this.singleIndex = index
         }else if(type == 7){
             list = this.tabulationList
              this.elementType = '列表'
               this.tabulationIndex = index
         }else if(type == 8){
             list = this.galleryList
              this.elementType = '图库'
               this.galleryIndex = index
         }else if(type == 9){
             list = this.progressList
              this.elementType = '进度条'
               this.progressIndex = index
         }else if(type == 10){
             list = this.captionList
              this.elementType = '文字'
               this.captionIndex = index
         }
         this.rightMenuList =  [
           {
              'name':'X',
              'key':(list[index].info.left).replace(/px/g, '')
            },
            {
              'name':'Y',
              'key':(list[index].info.top).replace(/px/g, '')
            },
            {
              'name':'宽',
              'key':(list[index].info.width).replace(/px/g, '')
            },
            {
              'name':'高',
              'key':(list[index].info.height).replace(/px/g, '')
            },
         ]
         this.rightChangeList = list[index]
         this.beforeLeft = (list[index].info.left).replace(/px/g, '')
         this.beforeTop = (list[index].info.top).replace(/px/g, '')
         this.elementIndex = index
      },
      //获取焦点
      rightFocus(type,index){
        this.eaitIndex = index
        this.rightChangeType  = type
      },
      //失去焦点
      curBlur_fn(type){
        var menuLeft = Number((this.rightMenStyle.left).replace(/px/g, ''))
        var menuTop = Number((this.rightMenStyle.top).replace(/px/g, ''))
        if(this.rightChangeType == 'X'){
          this.rightChangeList.info.left = type+'px'
          if(Number(type) > Number(this.beforeLeft)){
             var num = Number(type) - Number(this.beforeLeft)
             this.rightMenStyle.left = `${menuLeft + num}px`
          }
        }else if(this.rightChangeType == 'Y'){
           this.rightChangeList.info.top = type+'px'
           if(Number(type) > Number(this.beforeTop)){
             var num = Number(type) - Number(this.beforeTop)
             this.rightMenStyle.top = `${menuTop + num}px`
          }
        }else if(this.rightChangeType == '宽'){
           this.rightChangeList.info.width = type+'px'
        }else if(this.rightChangeType == '高'){
          this.rightChangeList.info.height = type+'px'
        }
       var that = this
       setTimeout(() => {
          if(that.elementType == '折线图'){
              that.proportionListLine[that.elementIndex].resize()
          }else if(that.elementType == '柱状图'){
              that.proportionListBar[that.elementIndex].resize()
          }else if(that.elementType == '饼图'){
               that.proportionListPie[that.elementIndex].resize()
          }
       },200)
        
      },
      //确定保存看板
      save_fn(){
        //保存之前，首先把图表、单值、进度条里所绑定的设备全部拿出来组成一个新的数组
        // this.editFlag = false
        // this.tranPercentage()
         var dataKeys = Object.keys(this.$data);
         var variables = {};
        for (var key of dataKeys) {
          variables[key] = this.$data[key];
        }
        var newArray = this.lineChartList.concat(this.barChartList, this.pieChartList, this.singleList,this.progressList);
        var newResParamete = []
        var panduan  = false
        newArray.forEach(item => {
          if(item.resParameter.resParameter == undefined){
                 panduan = true
                return
              }
              item.resParameter.resParameter.forEach(t => {
                newResParamete.push(t)
              })
        })
        var newArr = [variables]
        
        var d  = {
          'biType':this.routeData.kanBanType == '通用'? 'UNIVERSAL' : 'CUSTOMIZED',
          'content':"1",
          'biName':this.temp.biName,
          'memo':this.memo,
          'resParamete':JSON.stringify(newResParamete),
          'staticResource':CircularJSON.stringify(newArr),
          'uid':this.routeData.editUnitId
        }

        if(this.routeData.kanBanType == '指定'){
          d.unitId = this.routeData.unitId
          d.unitName  = this.routeData.unitName
        }
        if(panduan){
          this.$message({ message: '请确保绑定了变量！！！', type: 'warning' })
        }else {
          this.loading = true
              saveBI(d).then(res => {
                  if(res.code == 200){
                      this.$message({ message: '保存成功', type: 'success' });
                      this.dialogAdd = false
                      this.loading = false
                  }else {
                     this.loading = false
                     res.message != '' ?   this.$message({ message: `${res.message}`, type: 'error' }) : this.$message({ message: '保存失败', type: 'error' })
                  }
              })
        }
       

      },
      //保存之前把所有的px转化为百分比%
      tranPercentage(){
        //说明文字
        this.captionList.forEach(item => {
                    if(item.info.left.includes('%')){
                      item.info.left = ((this.tranString(item.info.left) / 100) * this.offsetWidth).toFixed(1) + 'px'
                    }
                    if(item.info.top.includes('%')){
                      item.info.top = ((this.tranString(item.info.top) / 100) * this.offsetHeight).toFixed(1) + 'px'
                    }
            })
       
          //  this.captionList.forEach(item => {
          //           item.info.left = ((this.tranString(item.info.left) / this.offsetWidth) * 100).toFixed(1) + '%'
          //           item.info.top = ((this.tranString(item.info.top) / this.offsetHeight) * 100).toFixed(1) + '%'
          //   })
      
            
           
        
         //进度条
        this.tranEverArr(this.progressList)
        //图库
         this.tranEverArr(this.galleryList)
        //模块
         this.tranEverArr(this.moveBoxList)
        //折线图
         this.tranEverArr(this.lineChartList)
        //柱状图
         this.tranEverArr(this.barChartList)
        //饼图
        this.tranEverArr(this.pieChartList)
        //单值
        this.tranEverArr(this.singleList)
        //列表
         this.tranEverArr(this.tabulationList)
      },
      //转化100px字符串之类的为数字型的100
      tranString(str){
          return Number(str.replace(/%/g, ""))
      },
      //转换各数组的
      tranEverArr(forArr){
          forArr.forEach(item => {
                    if(item.info.left.includes('%')){
                       item.info.left = ((this.tranString(item.info.left) / 100) * this.offsetWidth).toFixed(1) + 'px'
                    }
                    if(item.info.top.includes('%')){
                      item.info.top = ((this.tranString(item.info.top) / 100) * this.offsetHeight).toFixed(1) + 'px'
                    }
                    if(item.info.width.includes('%')){
                      item.info.width = ((this.tranString(item.info.width) / 100) * this.offsetWidth).toFixed(1) + 'px'
                    }
                    if(item.info.height.includes('%')){
                       item.info.height = ((this.tranString(item.info.height) / 100) * this.offsetHeight).toFixed(1) + 'px'
                    }
                    //  item.info.width = ((this.tranString(item.info.width) / 100) * this.offsetWidth).toFixed(1) + 'px'
                    //   item.info.left = ((this.tranString(item.info.left) / 100) * this.offsetWidth).toFixed(1) + 'px'
                    //   item.info.height = ((this.tranString(item.info.height) / 100) * this.offsetHeight).toFixed(1) + 'px'
                    //   item.info.top = ((this.tranString(item.info.top) / 100) * this.offsetHeight).toFixed(1) + 'px'
           })
      },
      //说明文字
      caption_fn(val){

              var d = val
              var leftPx = val.clientX
              var topPx = val.clientY
              // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
              // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
              d.info = {
                    'left':leftPx + 'px',
                    'top':topPx + 'px',
                }
                
              
                d.leftPx  = leftPx
                d.topPx  = topPx
            
                this.captionList.push(d)
        // this.caption.push(obj)
      },
      //文字点击
      captionClick_fn(index){
        this.quxiaoAll()
        this.captionIndex = index
        this.captionObj = JSON.parse(JSON.stringify(this.captionList[index]))
      },
       captionDraggable(e,index){
             e = e || window.event
             let odiv = (e.target).parentNode.parentNode
             if(odiv.className.includes('mycaption')){
                this.tagDraggable_fn(e,odiv,index,this.captionList)
              }
          },
      //文字样式改变
      changCaption_fn(obj){
        var index = this.captionIndex
           this.captionList[index].titleName  = obj.titleName
           this.captionList[index].fontSize  = obj.fontSize
           this.captionList[index].color  = obj.color
      },
      //进度条
      format(percentage) {
        return percentage < 0 ? `-${percentage}%` : `+${percentage}%`;
      },
      //进度条拖放
      progress_fn(val){

              var d = val
              var leftPx = val.clientX
              var topPx = val.clientY
              // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
              // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
              d.info = {
                    'left':leftPx + 'px',
                    'top':topPx + 'px',
                    'width':'300px',
                    'height':'20px',
                }
                d.tag = `progress${this.progressList.length + 1}`
                d.arrIndex = this.progressList.length
                d.leftPx  = leftPx
                d.topPx  = topPx
                this.progressList.push(d)
      },
      progressDraggable(e,index){
             e = e || window.event
              if((e.target).className.includes('progress-move')){
                 return
              }
             let demoArr = document.querySelectorAll('.myelprogress')
             let odiv = demoArr[index]
             if(odiv.className.includes('myelprogress')){
                this.tagDraggable_fn(e,odiv,index,this.progressList)
              }
          },
      //进度条点击
      progressClick_fn(index){
          this.quxiaoAll()
           this.tabIndex = 6  
          this.progressIndex = index
          this.progressObj = JSON.parse(JSON.stringify(this.progressList[index]))
      },
      changPro_fn(obj){
         this.progressList[this.progressIndex].spacing = obj.spacing
        if(obj.type == 1){
           this.progressList[this.progressIndex].lastColor = obj.lastColor
           this.progressList[this.progressIndex].sameColor = obj.sameColor
           this.progressList[this.progressIndex].resParameter = obj.resParameter
           this.progressList[this.progressIndex].lastCompare = obj.lastCompare
           this.progressList[this.progressIndex].sameCompare = obj.sameCompare
        }
      },
      //编辑栏拖放
      formulaBar(e){
        
             e = e || window.event
             let odiv = document.querySelector('.right-select')
             if(odiv.className.includes('right-select')){
                // this.tagDraggable_fn(e,odiv,index,this.singleList)
                   // 算出鼠标相对元素的位置
                    let disX = e.clientX - odiv.offsetLeft;
                    let disY = e.clientY - odiv.offsetTop;
                    if (e.preventDefault) {
                      e.preventDefault()
                    } else {
                      e.returnValue = false
                    }

                    document.onmousemove = (e) => {    //鼠标按下并移动的事件
                      // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                      this.zujianFlag = false
                      e = e || window.event
                      let left = e.clientX - disX;
                      let top = e.clientY - disY;
                    
                      // 标签不能移动到容器外
                      // left < 20 && (left =20)
                      // left > (width - odiv.offsetWidth - 20) && (left =(width - odiv.offsetWidth - 20))
                      // top < 20 && (top = 20)
                      // top > (height - odiv.offsetHeight - 40) && (top = height - odiv.offsetHeight - 40)

                      // 移动当前元素
                      odiv.style.left = `${left}px`;
                      odiv.style.top = `${top}px`;
                    }
                    document.onmouseup = (e) => {
                      document.onmousemove = null;
                      document.onmouseup = null;
                    };

              }
      },
      //图库拖放
      gallery_fn(val){
        
              var d = val
              var leftPx = val.clientX - (val.initialWidth / 2)
              var topPx = val.clientY  - (val.initialHeight / 2)
              // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
              // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
              
                d.info = {
                    'left':leftPx + 'px',
                    'top':topPx + 'px',
                    'width':val.newWidth,
                    'height':val.newHeght,
                }
                d.leftPx  = leftPx
                d.topPx  = topPx
                this.galleryList.push(d)
      },
      //图库点击
      galleryClick_fn(e,index){
        this.quxiaoAll()
        this.tabIndex = 7
        this.galleryIndex = index
        var list  = this.galleryList[index]
        list.initialWidth = e.target.offsetWidth,
        list.initialHeight = e.target.offsetHeight
        this.galleryObj =  list
      },
      //图库拖动
         galleryDraggable(e,index){
             e = e || window.event
             let odiv = (e.target).parentNode.parentNode
             if(odiv.className.includes('gallery-imgs')){
                this.tagDraggable_fn(e,odiv,index,this.galleryList)
              }
          },
      //图库改变
      changGallery_fn(obj){
             var list = this.galleryList[this.galleryIndex]
             list.info.width = obj.widthNum+'px'
             list.width = ((obj.widthNum / this.offsetWidth) * 100).toFixed(1)
             list.info.height = obj.heightNum + 'px'
             list.height = ((obj.heightNum / this.offsetHeight) * 100).toFixed(1)
             list.info.left = obj.leftPx + 'px'
             list.info.top = obj.topPx + 'px'
      },

      
      //时间
      timer_fn(){
        let date = new Date();
        let sign2 = ":";
        let year = date.getFullYear() // 年
        let month = date.getMonth() + 1; // 月
        let day = date.getDate(); // 日 
        let hour = date.getHours(); // 时
        let minutes = date.getMinutes(); // 分
        let seconds = date.getSeconds() //秒
        let weekArr = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        let week = weekArr[date.getDay()]; //getDay() 从 Date 对象返回一周中的某一天 (0 ~ 6)
        // 给一位数的数据前面加 “0”
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        if (hour >= 0 && hour <= 9) {
            hour = "0" + hour;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }
        this.nowTime = year + "-" + month + "-" + day
        this.nowWeek = week
        this.nowMin = hour + sign2 + minutes + sign2 + seconds
      },
      //为了解决点击菜单就消失
      addDel_fn(){},

      //输入框失去焦点或者按下回车
      blur_fn(val,index){
          this.nowChangeIndex = index
          this.eaitIndex = -1
          this.nowInputVal = val
      },
      //点击复制
      copy_fn(index){
                 this.copyData = []
                 this.copyData.push(this.moveBoxList[index])
      },
      
      //取消右击菜单跟模块高亮
      leftDemoClick(e){
         this.layerX = e.layerX
         this.layerY = e.layerY
       this.quxiaoAll()
        
      },
      //取消全部高亮
      quxiaoAll(){
        this.captionIndex = -1
         this.moveBoxIndex = -1
        this.weathIndex = -1
        this.chartIndex = -1
        this.pieChartIndex = -1
        this.barChartIndex = -1
        this.tabulationIndex = -1
        this.singleIndex = -1
        this.galleryIndex = -1
        this.progressIndex = -1
        this.isRightMenu = false
        this.nowChartData = {}
        this.nowTabulationData = {}
        this.nowSingleData = {}
        this.galleryObj = {}
        this.captionObj = {}
        this.progressObj = {}
      },
      moveBoxClick_fn(index){
        this.quxiaoAll()
        this.moveBoxIndex = index
       this.tabIndex = 1
       
         this.nowModulTitleObj = this.moveBoxList[index]
      },
        //下载图片
       generateImages () {
            html2canvas(document.querySelector('.left-demo')).then(canvas => {
            const imgUrl = canvas.toDataURL('image/jpeg')
            const image = document.createElement('img')
            image.src = imgUrl
            // 将生成的图片放到 类名为 content 的元素中
            // document.querySelector('.content').appendChild(image)
            const a = document.createElement('a')
            a.href = imgUrl
            // a.download 后面的内容为自定义图片的名称
            a.download = 'study_download'
            a.click()
            })
        },
       
        //自定义宽度
        moveLineWidth(e,index,type,i) {
      
            let moveBoxObj = document.getElementById(index)// 最大的框，自带相对定位属性
            let moveStartX = e.clientX 
            var that = this
            // var indexs = moveBoxObj.id.slice(-1)
            let moveLineObjOffsetLeft = moveBoxObj.offsetWidth // 得到点击时该line的左边距
            let offsetLeft = moveBoxObj.offsetLeft
            var list = []
            if(type == 0){ //模块
              list  = this.moveBoxList
            }else if(type == 1){ //折线图
              list = this.lineChartList
            }else if(type == 2){ //柱状图
                 list = this.barChartList
            }else if(type == 3){ //饼图
                 list = this.pieChartList
            }

             document.onmousemove = (e) => {    //鼠标按下并移动的事件
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                e = e || window.event
                 let mouseMoveDistance = e.clientX - moveStartX // 鼠标滑动距离（正则是往右；负则是往左）
                 let styleLeft = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                 styleLeft = styleLeft >= (that.offsetWidth - 20 - offsetLeft) ? (that.offsetWidth - 20 - offsetLeft) : styleLeft
                //  styleLeft =  ( (styleLeft / that.offsetWidth).toFixed(3) ) * 100  < 23 ? 23 :  ( (styleLeft / that.offsetWidth).toFixed(3) ) * 100
                 list[i].info.width = styleLeft + 'px'
                //  list[i].width = ((styleLeft / 100) * that.offsetWidth).toFixed(1)
                 if(type == 1){
                      this.proportionListLine[i].resize()
                 }else if(type == 2){
                     this.proportionListBar[i].resize()
                 }else if(type == 3){
                    this.proportionListPie[i].resize()
                 }
                }
             document.onmouseup = (e) => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                  
                 };
            
        },
        //自定义高度
        moveLineHeight(e,index,type,i){
                let moveBoxObj = document.getElementById(index) // 最大的框，自带相对定位属性
                // var indexs = moveBoxObj.id.slice(-1)
                let moveStartY = e.clientY 
                 var that = this
                let moveLineObjOffsetLeft = moveBoxObj.offsetHeight // 得到点击时该line的左边距
                let offsetTop = moveBoxObj.offsetTop
                var list = []
                if(type == 0){ //模块
                  list  = this.moveBoxList
                }else if(type == 1){ //折线图
                  list = this.lineChartList
                }else if(type == 2){ //柱状图
                    list = this.barChartList
                }else if(type == 3){ //饼图
                 list = this.pieChartList
                }
                  document.onmousemove = (e) => {    //鼠标按下并移动的事件
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                 e = e || window.event
                 let mouseMoveDistance = e.clientY - moveStartY // 鼠标滑动距离（正则是往右；负则是往左）
                 let styleHeight = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                 styleHeight = styleHeight >= (that.offsetHeight - 45 - offsetTop) ? (that.offsetHeight - 45 - offsetTop) : styleHeight
                //  styleHeight =  ( (styleHeight / (that.offsetHeight)).toFixed(3) ) * 100  < 20 ? 20 :  ( (styleHeight / (that.offsetHeight )).toFixed(3) ) * 100
                 list[i].info.height = styleHeight + 'px'
                //  list[i].height = ((styleHeight / 100) * that.offsetHeight).toFixed(1)

                  if(type == 1){
                      this.proportionListLine[i].resize()
                 }else if(type == 2){
                     this.proportionListBar[i].resize()
                 }else if(type == 3){
                    this.proportionListPie[i].resize()
                 }
                }
                document.onmouseup = (e) => {
                        document.onmousemove = null;
                        document.onmouseup = null;
                       
                    };
        },

         //图表自定义宽度
        moveChartWidth(e,index,type,i) {
      
            let moveBoxObj = document.getElementById(index)// 最大的框，自带相对定位属性
            let moveStartX = e.clientX 
            var that = this
            // var indexs = moveBoxObj.id.slice(-1)
            let moveLineObjOffsetLeft = moveBoxObj.offsetWidth // 得到点击时该line的左边距
            let offsetLeft = moveBoxObj.offsetLeft
            var list = []
            if(type == 0){ //模块
              list  = this.moveBoxList
            }else if(type == 1){ //折线图
              list = this.lineChartList
            }else if(type == 2){ //柱状图
                 list = this.barChartList
            }else if(type == 3){ //饼图
                 list = this.pieChartList
            }

             document.onmousemove = (e) => {    //鼠标按下并移动的事件
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                e = e || window.event
                 let mouseMoveDistance = e.clientX - moveStartX // 鼠标滑动距离（正则是往右；负则是往左）
                 let styleLeft = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                 styleLeft = styleLeft >= (that.offsetWidth - 20 - offsetLeft) ? (that.offsetWidth - 20 - offsetLeft) : styleLeft
                //  styleLeft =  ( (styleLeft / that.offsetWidth).toFixed(3) ) * 100
                 list[i].info.width = styleLeft + 'px'
                //  list[i].width = ((styleLeft / 100) * that.offsetWidth).toFixed(1)
                 if(type == 1){
                      this.proportionListLine[i].resize()
                 }else if(type == 2){
                     this.proportionListBar[i].resize()
                 }else if(type == 3){
                    this.proportionListPie[i].resize()
                 }
                }
             document.onmouseup = (e) => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                  
                 };
            
        },
        //图表自定义高度
        moveChartHeight(e,index,type,i){
                let moveBoxObj = document.getElementById(index) // 最大的框，自带相对定位属性
                // var indexs = moveBoxObj.id.slice(-1)
                let moveStartY = e.clientY 
                 var that = this
                let moveLineObjOffsetLeft = moveBoxObj.offsetHeight // 得到点击时该line的左边距
                let offsetTop = moveBoxObj.offsetTop
                var list = []
                if(type == 0){ //模块
                  list  = this.moveBoxList
                }else if(type == 1){ //折线图
                  list = this.lineChartList
                }else if(type == 2){ //柱状图
                    list = this.barChartList
                }else if(type == 3){ //饼图
                 list = this.pieChartList
                }
                  document.onmousemove = (e) => {    //鼠标按下并移动的事件
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                 e = e || window.event
                 let mouseMoveDistance = e.clientY - moveStartY // 鼠标滑动距离（正则是往右；负则是往左）
                 let styleHeight = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                 styleHeight = styleHeight >= (that.offsetHeight - 45 - offsetTop) ? (that.offsetHeight - 45 - offsetTop) : styleHeight
                //  styleHeight =  ( (styleHeight / (that.offsetHeight)).toFixed(3) ) * 100
                //  list[i].info.height = styleHeight.toFixed(2) + '%'
                 list[i].info.height = styleHeight + 'px'

                  if(type == 1){
                      this.proportionListLine[i].resize()
                 }else if(type == 2){
                     this.proportionListBar[i].resize()
                 }else if(type == 3){
                    this.proportionListPie[i].resize()
                 }
                }
                document.onmouseup = (e) => {
                        document.onmousemove = null;
                        document.onmouseup = null;
                       
                    };
        },
        //添加模块
        addMoveBox_fn(){

            if(this.moveBoxList.length >= 16){
                this.$message({ showClose: true, message: '最多不能超过16个模块！', type: 'warning'});
                return
            }
           var leftPx = this.coordinate.clientX - 130
           var topPx = this.coordinate.clientY - 40
            // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
            // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
            var d = {
                'id':new Date().getTime(),
                'info':{
                  'left':leftPx + 'px',
                  'top':topPx + 'px',
                  'width':'260px',
                  'height':'200px',
                },
                'titleStyle':{
                  'name':'标题',
                  'fontSize':"16px" ,
                  'color':"#fff",
                },
                'type':this.coordinate.type,
                'iconImgType':this.coordinate.iconImgType,
                'iconImgIndex':this.coordinate.iconImgIndex,
                'iconImg':this.coordinate.iconImg,
                'cheekImgType':this.coordinate.cheekImgType,
                 'cheekImgIndex':this.coordinate.cheekImgIndex,
                'cheekImg':this.coordinate.cheekImg,
                'iconFlag':this.coordinate.iconFlag
            }
            if(this.coordinate.type == 1){
              d.info.backgroundImage = `url(${this.coordinate.cheekImg})`
              // d.info.backgroundColor = 'red'
            }
            this.moveBoxList.push(d)
            this.moveBoxIndex = this.moveBoxList.length - 1
             this.weathIndex = -1
             
 
            
        },
        //删除模块
        del_fn(index,type){
            // var dom=document.getElementById(divId);
	          // dom.parentNode.removeChild(dom);
            setTimeout(() => {
               if(type == '模块'){
                   this.moveBoxList.splice(index,1)
               }else if(type == '天气'){
                   this.weatherList.splice(index,1)
               }else if(type == '时间'){
                   this.timerList.splice(index,1)
               }else if(type == '折线图'){
                  this.lineChartList.splice(index,1)
                  this.proportionListLine.splice(index,1)
               }else if(type == '柱状图'){
                   this.barChartList.splice(index,1)
                   this.proportionListBar.splice(index,1)
               }else if(type == '饼图'){
                   this.pieChartList.splice(index,1)
                   this.proportionListPie.splice(index,1)
               }else if(type == '单值'){
                   this.singleList.splice(index,1)
               }else if(type == '列表'){
                   this.tabulationList.splice(index,1)
               }else if(type == '图库'){
                   this.galleryList.splice(index,1)
               }else if(type == '进度条'){
                   this.progressList.splice(index,1)
               }else if(type == '文字'){
                   this.captionList.splice(index,1)
               }
               this.isRightMenu = false
            },500)
        },
        // 模块拖拽
      tagDraggable (e,index) {
     
        // 获取目标元素
        e = e || window.event
        let odiv = e.target;
        // var moveBoxAll  = document.querySelectorAll('.moveBox')
        if(odiv.className.includes('top-title')){
          odiv = (e.target).parentNode
        }

        if (!odiv.className.includes('moveBox')) return
        this.tagDraggable_fn(e,odiv,index,this.moveBoxList)
      },
      tagDraggable_fn(e,odiv,index,data){
          // 算出鼠标相对元素的位置
        let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
        let width = this.$refs.dragContent.offsetWidth
        let height = this.$refs.dragContent.offsetHeight
        document.onmousemove = (e) => {    //鼠标按下并移动的事件
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          this.zujianFlag = false
          e = e || window.event
          let left = e.clientX - disX;
          let top = e.clientY - disY;
         
          // 标签不能移动到容器外
          left < 10 && (left =10)
          left > (width - odiv.offsetWidth - 10) && (left =(width - odiv.offsetWidth - 10))
          top < 5 && (top = 5)
          top > (height - odiv.offsetHeight - 10) && (top = height - odiv.offsetHeight - 10)

          // 移动当前元素
          odiv.style.left = `${left}px`;
          odiv.style.top = `${top}px`;
            data[index].info.left = `${left}px`
          data[index].info.top = `${top}px`
        }
        document.onmouseup = (e) => {
        
          document.onmousemove = null;
          document.onmouseup = null;
        };
      },
      //鼠标右键
      rightClick(e,index){
          e = e || window.event
           let odiv = e.target;
            var   arr =  odiv.childNodes
            let appoint = ""
            for(let i = 0;i<arr.length;i++){
                if(arr[i].className == 'add-del'){
                    appoint = arr[i]
                }
            }
            appoint.style.left = `${e.offsetX}px`;
            appoint.style.top = `${e.offsetY}px`;
              this.moveBoxList.forEach(item => {
                item.rightMenu = false
              })
              this.moveBoxIndex = index
             this.moveBoxList[index].rightMenu = true

      },
      //大标题拖放
      titleMove(e){
        e = e || window.event
        let odiv = e.target;     
         let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
        let height = this.$refs.dragContent.offsetHeight
        // var newtop = odiv.offsetTop
        document.onmousemove = (e) => {    //鼠标按下并移动的事件
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          e = e || window.event
          let top = e.clientY - disY;
         
          top < 4 && (top = 4)
          top > (height - odiv.offsetHeight - 70) && (top = height - odiv.offsetHeight - 70)
          
          odiv.style.top = `${top}px`;
          this.fontSize.top = `${top}px`
        }
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null;
        };

      },
      //上传背景图片
       handlePictureCardPreview(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file.raw); 
        reader.onload = () => {
          this.dialogImageUrl = reader.result; // 将base64编码的字符串赋值给imageUrl，用于显示上传的图片
        };
        this.dialogVisible = true
      },
      //上传主题
      zhutiImg_fn(file){
         var reader = new FileReader();
        reader.readAsDataURL(file.raw); 
        //  this.bgImgList.push({'url':file.url})
         reader.onload = () => {
            this.bgImgList.push({'url':reader.result}) // 将base64编码的字符串赋值给imageUrl，用于显示上传的图片
        };
      },
      //切换背景
      change_bg(index){
        this.activeIndex = index
        if(this.switchValue){
            if(index < 8){
                this.nowBgImg = {backgroundImage: `url(${this.bgImgList[index].urlTran})`}
            }else {
                 this.nowBgImg = {backgroundImage: `url(${this.bgImgList[index].url})`}
            }
        }else {
            this.nowBgImg = {backgroundImage: `url(${this.bgImgList[index].url})`}
        }
      },
      //启用禁用背景图片
      switch_fn(val){
        if(val){
            this.nowBgImg = {backgroundImage: `url(${this.bgImgList[this.activeIndex].urlTran})`}
        }else {
            this.nowBgImg = {backgroundImage: `url(${this.bgImgList[this.activeIndex].url})`}

        }
      },
      //标题字体
      fontSize_fn(){
         this.fontSize = {fontSize:this.sizeValue+'px',color:this.titleColor}
      },
      //字体颜色
      color_fn(val){
           this.titleColor = val
           this.fontSize = {fontSize:this.sizeValue+'px',color:this.titleColor}
      },
      //小模块标题形状
      shape_fn(val){
        this.shapeValue = val
        this.moduleStyle()
      },
      //小模块标题图标
      nowIcon_fn(val){
        if(this.moveBoxIndex == -1){
          this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
          this.moveBoxList[this.moveBoxIndex].iconImgType = val.iconValue
          this.moveBoxList[this.moveBoxIndex].iconImg = val.iconImg
          this.moveBoxList[this.moveBoxIndex].iconImgIndex = val.iconImgIndex
      },
      //图标是否启用
      iconFlag_fn(val){
        if(this.moveBoxIndex == -1){
          this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
        this.moveBoxList[this.moveBoxIndex].iconFlag = val
      },
      //小模块有边框类型
      nowCheek_fn(val){
        if(this.moveBoxIndex == -1){
           this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
          this.moveBoxList[this.moveBoxIndex].cheekImgType = val.cheekImgType
          this.moveBoxList[this.moveBoxIndex].cheekImg = val.cheekImg
          this.moveBoxList[this.moveBoxIndex].info.backgroundImage = `url(${val.cheekImg})`
          this.moveBoxList[this.moveBoxIndex].cheekImgIndex = val.cheekImgIndex
      },
      //小模块标题背景渐变
      moduleTitle_fn(val){
           this.moduleBgColor = val
           this.moduleStyle()
      },
      //小模块标题背景颜色
      moduleTitleColor_fn(val){
        this.moduleTitleColor  =  val
        this.moduleStyle()
      },
      //小模块小标题样式
      modelTitleName_fn(obj){
           if(this.moveBoxIndex == -1){
           this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
        this.moveBoxList[this.moveBoxIndex].title = obj.name
          this.moveBoxList[this.moveBoxIndex].titleStyle = obj
      },
      //小模块样式统一变动
      moduleStyle(){
        this.deltaObj  =  {borderRightColor:this.moduleTitleColor}
            if(this.moduleBgColor){
               this.topTitleObj = {background:`linear-gradient(to right, ${this.moduleTitleColor}, transparent)`}
               this.lineObj = {background:`linear-gradient(to right, ${this.moduleTitleColor}, transparent)`}
            }else  {
                this.topTitleObj = {background:this.moduleTitleColor}
                this.lineObj = {background:this.moduleTitleColor}
            }
            if(this.shapeValue == '直线') {
                  this.topTitleObj  = {background:`transparent`}
            }
      },
      //小模块拖放
      coordinate_fn(obj){
        this.coordinate  =  obj
       
        this.addMoveBox_fn()
      },
      //组件拖放
      assembly_fn(val){
          //  let width = this.$refs.dragContent.offsetWidth
          //  let height = this.$refs.dragContent.offsetHeight
           var d = val
            var leftPx = val.clientX - 140
           var topPx = val.clientY
           if(val.type == 0 || val.type ==1){
              leftPx = val.clientX - 12
              topPx = val.clientY 
           }
            // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
            // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
            d.info = {
                'left':leftPx + 'px',
                'top':topPx + 'px',
                'color':val.color
            }
        if(val.type == 0){
          this.fullScreenStyle = []
          this.fullScreenStyle.push(d)

           this.$refs.assembly.screenChange(0,d)
        }
        if(val.type == 1){
           this.renovateStyle = []
           this.renovateStyle.push(d)
            this.$refs.assembly.screenChange(1,d)
        }
           
         if(val.type == 2){
            this.weatherList.push(d)
            setTimeout(() => {
              var weatherAll  = document.querySelectorAll('.weather')
              var div = weatherAll[weatherAll.length - 1]
              // div.style.width = (( (div.offsetWidth / width).toFixed(3) ) * 100) + 2  + '%'
              div.style.width = div.offsetWidth  + 'px'
             
            },1000)
            this.weathIndex = this.weatherList.length - 1
            this.timerIndex = -1
            
         }
         if(val.type == 3){
            this.timerList.push(d)
            setTimeout(() => {
              var timerAll  = document.querySelectorAll('.timer')
              var div = timerAll[timerAll.length - 1]
              // div.style.width = (( (div.offsetWidth / width).toFixed(3) ) * 100) + 2  + '%'
              div.style.width = div.offsetWidth  + 'px'
             
            },500)
            this.timerIndex = this.timerList.length - 1
            this.weathIndex = -1
         }
         this.moveBoxIndex = -1
      },
      //组件天气拖放
      zujianTagDraggable(e,index,type){
          e = e || window.event
          let odiv = (e.target).parentNode;
          var arr = []
          if(type == 0) {
            arr = this.fullScreenStyle
          }
          if(type == 1){
            arr = this.renovateStyle
          }
          if(type == 2){
            arr = this.weatherList
          }
          if(type == 3){
            arr = this.timerList
          }
          this.zujianFlag = true
          this.tagDraggable_fn(e,odiv,index,arr)
      },
      //全屏/缩小/刷新
      screens_fn(val){  
        if(val.type == 0){
           this.operationTips(this.fullScreenStyle.length == 0 , '请选择全屏/缩小')
           this.fullScreenStyle[0].info.color = val.color
        }else {
          this.operationTips(this.renovateStyle.length == 0 , '请选择刷新')
           this.renovateStyle[0].info.color = val.color
        }
      },
      //全屏/缩小/刷新
      screenRenovate_fn(val,obj){
        if(this.settingFlag && this.zujianFlag){
            var flag = resourcesStore.state.customKanBanScreen
            this.screenFlag = !flag

           resourcesStore.commit('setCustomKanBan',!flag)
          
        }
        this.tabIndex = 2
        this.$refs.assembly.screenChange(val,obj)
      },

      //组件天气样式变化
      weathers_fn(val){
       this.operationTips(this.weathIndex == -1 , '请选择需要更改的组件')
        this.weatherList[this.weathIndex].info.color = val.color
        this.weatherList[this.weathIndex].weatherCheckList = val.weatherCheckList

      },
       //组件时间样式变化
      timers_fn(val){
          this.operationTips(this.timerIndex == -1 , '请选择需要更改的组件')
        this.timerList[this.timerIndex].info.color = val.color
        this.timerList[this.timerIndex].timerCheckList = val.timerCheckList

      },
      //操作提示
      operationTips(term,word){
          if(term ){
          this.$message({ message:word, type: 'warning' });
            return 
          }
      },
      

      //图表组件相关操作(以下)
      chart_fn(obj){
        var data = obj
            var leftPx = obj.clientX - 200
            var topPx = obj.clientY - 60
            // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
            // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
            data.info = {
                'left':leftPx + 'px',
                'top':topPx + 'px',
                'width':'550px',
                'height':'200px'
            }
        if(data.type == '折线图'){
          data.arrIndex = this.lineChartList.length
          this.lineChartList.push(data)
          data.tag = 'CHART_LINE'+this.lineChartList.length
        }else if(data.type == '柱状图'){
          data.arrIndex = this.barChartList.length
           this.barChartList.push(data)
            data.tag = 'CHART_BAR'+this.barChartList.length
        }else if(data.type == '饼图'){
            data.info.width  = '500px'
            data.info.height  = '500px'
             data.arrIndex = this.pieChartList.length
            this.pieChartList.push(data)
            data.tag = 'CHART_PIE'+this.pieChartList.length
        }
        //  this.proportionListLine.push(`proportions${this.lineChartList.length}`)
        var that = this
       setTimeout(() => {
        
          //  this.proportionListLine[this.lineChartList.length-1] = echarts.init(document.getElementById(`proportion${this.lineChartList.length}`));
           if(data.type == '折线图'){
             that.proportionListLine.push(echarts.init(document.getElementById(`proportion${that.lineChartList.length}`)));
             that.proportionListLine[that.lineChartList.length-1].setOption(obj.optionData,true);
            }else if(data.type == '柱状图'){
               that.proportionListBar.push(echarts.init(document.getElementById(`proportionBar${that.barChartList.length}`)));
               that.proportionListBar[that.barChartList.length-1].setOption(obj.optionData,true);
            }else if(data.type == '饼图'){
               that.proportionListPie.push(echarts.init(document.getElementById(`proportionPie${that.pieChartList.length}`)));
               that.proportionListPie[that.pieChartList.length-1].setOption(obj.optionData,true);
            }
       },200)
          
      },
      //图表拖动
      chartDraggable(e,index,type){
          e = e || window.event
          let odiv = (e.target).parentNode.parentNode.parentNode;
          if(type == '折线图'){
            if(odiv.className.includes('line-chart')){
              this.tagDraggable_fn(e,odiv,index,this.lineChartList)
            }
          }else if(type == '柱状图'){
              if(odiv.className.includes('bar-chart')){
                this.tagDraggable_fn(e,odiv,index,this.barChartList)
              }
          }else if(type == '饼图'){
              if(odiv.className.includes('pie-chart')){
                this.tagDraggable_fn(e,odiv,index,this.pieChartList)
              }
          }
      },
      //点击图表
      chartClick_fn(index,type){
         this.tabIndex = 3
         this.chartType = type
          this.quxiaoAll()
         if(type == '折线图'){
           this.chartIndex = index
           this.nowChartData = JSON.parse(JSON.stringify(this.lineChartList[index]))
         }else if(type == '柱状图'){
             this.barChartIndex = index
             this.nowChartData = JSON.parse(JSON.stringify(this.barChartList[index]))
         }else if(type == '饼图'){
             this.pieChartIndex = index
             this.nowChartData = JSON.parse(JSON.stringify(this.pieChartList[index]))
         }
         
      },
      //改变图表
      changChart(obj,loadData){
        if(this.chartType == '折线图'){
              this.lineChartList[this.chartIndex].optionData = obj
              this.lineChartList[this.chartIndex].resParameter = loadData //绑定的变量
              this.proportionListLine[this.chartIndex].setOption(obj,true);
          }else if(this.chartType =='柱状图'){
                this.barChartList[this.barChartIndex].optionData = obj
                this.barChartList[this.barChartIndex].resParameter = loadData //绑定的变量
                this.proportionListBar[this.barChartIndex].setOption(obj,true);
          }else if(this.chartType == '饼图'){
                this.pieChartList[this.pieChartIndex].optionData = obj
                this.proportionListPie[this.pieChartIndex].setOption(obj,true);
          }
      },
      //图表组件相关操作(以上)
      settingFlag_fn(val){
        this.settingFlag  = val
        // if(this.lineChartList.length != 0){
        //   setTimeout(() => {
        //      this.proportionListLine.forEach(item => item.resize())
        //   },500)
        // } 
        // if(this.barChartList.length != 0){
        //    setTimeout(() => {
        //      this.proportionListBar.forEach(item => item.resize())
        //   },500)
        // }
        // if(this.pieChartList.length != 0){
        //    setTimeout(() => {
        //      this.proportionListPie.forEach(item => item.resize())
        //   },500)
        // }
      },

      //单值操作(以下)
          //拖放
          single_fn(obj){
              // let width = this.$refs.dragContent.offsetWidth
              // let height = this.$refs.dragContent.offsetHeight
              var d = obj
              var leftPx = obj.clientX - 50
              var topPx = obj.clientY - 30
              // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
              // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
                d.info = {
                    'left':leftPx + 'px',
                    'top':topPx + 'px',
                    'width':'150px',
                    'height':'150px',
                    'borderColor':obj.modelColor
                }
                //type 为0则是基础单值
                //type 为1则是复合单值
                d.biCategory = 'SINGLE_ASSORTED'
                d.arrIndex = this.singleList.length
                d.tag = `SINGLE_ASSORTED${this.singleList.length+1}`
                this.singleList.push(d)
                // this.singleIndex = this.singleList.length - 1  
          },
          //点击
          singleClick_fn(index){
            this.quxiaoAll()
              this.singleIndex = index
              this.tabIndex = 4  
              this.nowSingleData = JSON.parse(JSON.stringify(this.singleList[index]))
          },
          //改变单值
          changSingle_fn(obj){
             var list  = this.singleList[this.singleIndex]
             list.timeVal = obj.timeVal
             list.titleBgColor = obj.titleBgColor
             list.titleColor = obj.titleColor
             list.titleIcon = obj.titleIcon
             list.titleName = obj.titleName
             list.valBgColor = obj.valBgColor
             list.valColor = obj.valColor
             list.modelColor = obj.modelColor
             list.valIcon = obj.valIcon
             list.info.borderColor =  obj.modelColor
          },
          //改变复合单值
          fusingleChange_fn(obj){
                var list  = this.singleList[this.singleIndex]
                list.hangStyle = obj.hangStyle
                list.huanValStyle = obj.huanValStyle
                list.timeVal = obj.timeVal
                list.tongStyle = obj.tongStyle
                list.tongValStyle = obj.tongValStyle
                list.yuanStyle = obj.yuanStyle
                list.yuanValStyle = obj.yuanValStyle
                list.switchVal = obj.switchVal
                list.resParameter = obj.resParameter
                // list.checkedNodes = obj.checkedNodes
                // list.handleArr = obj.handleArr
                list.originalValue = obj.originalValue
                list.lastCompareValue = obj.lastCompareValue
                list.sameCompareValue = obj.sameCompareValue
          },
          //拖动
          singleDraggable(e,index){
             e = e || window.event
             var tar = (e.target)
             let odiv = tar.parentNode.parentNode
             if(odiv.className.includes('single-value')){
                this.tagDraggable_fn(e,odiv,index,this.singleList)
              }
               if(tar.className.includes('single-item')){
                var newDiv = tar.parentNode
                this.tagDraggable_fn(e,newDiv,index,this.singleList)
              }
          },
          //复合单值拖动
          singleItemDraggable(e,index){
             e = e || window.event
             let odiv = (e.target).parentNode
             var list  = this.singleList[index]
             if(odiv.className.includes('fuhe-origina')){
                 this.fusingleTuodong(e,odiv,list.yuanXY)
              }else if(odiv.className.includes('fuhe-huan')){
                 this.fusingleTuodong(e,odiv,list.hangXY)
              }else if(odiv.className.includes('fuhe-tong')){
                 this.fusingleTuodong(e,odiv,list.tongXY)
              }
          },
          fusingleTuodong(e,odiv,data){
               // 算出鼠标相对元素的位置
                let disX = e.clientX - odiv.offsetLeft;
                let disY = e.clientY - odiv.offsetTop;
                if (e.preventDefault) {
                  e.preventDefault()
                } else {
                  e.returnValue = false
                }

               
                document.onmousemove = (e) => {    //鼠标按下并移动的事件
                  // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  this.zujianFlag = false
                  e = e || window.event
                  let left = e.clientX - disX;
                  let top = e.clientY - disY;
                  // 移动当前元素
                  // odiv.style.left = `${left}px`;
                  // odiv.style.top = `${top}px`;
                  data.top = `${top}px`
                  data.left = `${left}px`
                }
                document.onmouseup = (e) => {
                  document.onmousemove = null;
                  document.onmouseup = null;
                };
          },
          //自定义宽度
          singleMoveLineWidth(e,index,type,i) {
              
              let moveBoxObj = document.getElementById(index)// 最大的框，自带相对定位属性
              let moveStartX = e.clientX 
              var that = this
              // var indexs = moveBoxObj.id.slice(-1)
              let moveLineObjOffsetLeft = moveBoxObj.offsetWidth // 得到点击时该line的左边距
              let offsetLeft = moveBoxObj.offsetLeft
              var list = []
              if(type == 1){
                list = this.singleList
              }else if(type == 2){
                 list = this.tabulationList
              }else if(type == 3){
                list  = this.galleryList
              }else if(type == 4){
                 list = this.progressList
              }
              document.onmousemove = (e) => {    //鼠标按下并移动的事件
                  // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  e = e || window.event
                  let mouseMoveDistance = e.clientX - moveStartX // 鼠标滑动距离（正则是往右；负则是往左）
                  let styleLeft = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                  styleLeft = styleLeft >= (that.offsetWidth - 20 - offsetLeft) ? (that.offsetWidth - 20 - offsetLeft) : styleLeft
                  // styleLeft =  ( (styleLeft / that.offsetWidth).toFixed(3) ) * 100 
                  list[i].info.width = styleLeft + 'px'
                  // list[i].width = ((styleLeft / 100) * that.offsetWidth).toFixed(1)
                  
                  }
              document.onmouseup = (e) => {
                      document.onmousemove = null;
                      document.onmouseup = null;
                    
                  };
              
          },
          //自定义高度
          singleMoveLineHeight(e,index,type,i){
                  
                  let moveBoxObj = document.getElementById(index) // 最大的框，自带相对定位属性
                  // var indexs = moveBoxObj.id.slice(-1)
                  let moveStartY = e.clientY 
                  var that = this
                  let moveLineObjOffsetLeft = moveBoxObj.offsetHeight // 得到点击时该line的左边距
                  let offsetTop = moveBoxObj.offsetTop
                 var list = []
                  if(type == 1){
                    list = this.singleList
                  }else if(type == 2){
                    list = this.tabulationList
                  }else if(type == 3){
                    list  = this.galleryList
                  }else if(type == 4){
                    list = this.progressList
                  }
                  
                    document.onmousemove = (e) => {    //鼠标按下并移动的事件
                  // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  e = e || window.event
                  let mouseMoveDistance = e.clientY - moveStartY // 鼠标滑动距离（正则是往右；负则是往左）
                  let styleHeight = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                  styleHeight = styleHeight >= (that.offsetHeight - 45 - offsetTop) ? (that.offsetHeight - 45 - offsetTop) : styleHeight
                  // styleHeight =  ( (styleHeight / (that.offsetHeight)).toFixed(3) ) * 100
                  list[i].info.height = styleHeight + 'px'
                  // list[i].height = ((styleHeight / 100) * that.offsetHeight).toFixed(1)

                  }
                  document.onmouseup = (e) => {
                          document.onmousemove = null;
                          document.onmouseup = null;
                        
                      };
          },
          
      //单值操作(以上)
         
      //列表操作(以下)
          //拖放
          tabulation_fn(obj){
            this.tabulationList  = []

              var d = obj
              var leftPx = obj.clientX - 50
              var topPx = obj.clientY - 30
              // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
              // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
                d.info = {
                    'left':leftPx + 'px',
                    'top':topPx + 'px',
                    'width':'300px',
                    'height':'200px',
                }
                this.tabulationList.push(d)
                this.tabulationIndex = 0
          },
          changtabulation_fn(obj){
             this.tabulationList[0].alarm = obj.alarm
             this.tabulationList[0].warning = obj.warning
             this.tabulationList[0].notice = obj.notice
             this.tabulationList[0].con = obj.con
             this.tabulationList[0].time = obj.time
             this.tabulationArr = []
             for(let i = 0;i <= obj.rowVal - 1;i++){
                  this.tabulationArr.push(this.tabulationArrCopy[i])
              }
             
          },
          tabulationClick_fn(){
               this.tabulationIndex = 0
                this.tabIndex = 5
                this.pieChartIndex = -1
                this.barChartIndex = -1
                 this.moveBoxIndex = -1
                this.weathIndex = -1
                 this.singleIndex = -1
               this.nowTabulationData = JSON.parse(JSON.stringify(this.tabulationList[0]))
          },
           //拖动
          tabDraggable(e,index){
             e = e || window.event
             var dome = (e.target)
             let odiv = ""
             if(dome.className.includes('tabulationone')){
                odiv = dome
             }else {
               odiv = (e.target).parentNode.parentNode
              }
             if(odiv.className.includes('tabulation-item')){
                odiv = odiv.parentNode
             }
             if(odiv.className.includes('tabulationone')){
                this.tagDraggable_fn(e,odiv,index,this.tabulationList)
              }
          },
         
      //列表操作(以上)
      //保存看板
      preserve_fn(){
        var that = this
        this.countNum = 3
        this.disabledFlag = true
        this.dialogAdd = true
        var timerId = setInterval(function(){
            that.countNum--
            if(that.countNum == 0){
              clearInterval(timerId);
               that.disabledFlag = false
            }
          }, 1000);

      },
      
        
    },
    

}
</script>
<style lang="scss" scoped>
  .customKanBan-active {
        position: absolute;
        // z-index: 100;
        // top: -45px;
        top:-50px;
        margin-top: 0px !important;
        height: 100% !important;
  }
  @import './customKanBan.scss';
</style>
